module.exports = __webpack_public_path__ + "img/slphouse_main2.80dffdf3.png";